export default "__VITE_ASSET__Bo22ohfx__"